import { flagKeys, tenantFlagKeys } from '@features/feature-flags';

import { componentKeys } from '../hooks/use-components';
import { releaseKeys } from '../hooks/use-release-components';

import { isTerminal } from './operation-status';

import type { LastAction } from '../schemas/release-component';

/** Prefixes that an operation's writes made stale (spec: The Web Refreshes What Operations Changed). */
export function operationInvalidationKeys(releaseId: string): (readonly string[])[] {
    return [
        releaseKeys.detail(releaseId),
        flagKeys.all,
        tenantFlagKeys.all,
        [...componentKeys.all, 'holdings'],
    ];
}

/**
 * Remembers the last state seen per operation and invalidates once when it moves
 * from running to a terminal state. An operation first seen already finished
 * changed nothing under the page, so it invalidates nothing. A retry back to
 * `running` re-arms the same operation.
 */
export function createTerminalInvalidation(
    releaseId: string,
    invalidate: (key: readonly string[]) => void,
) {
    const seen = new Map<string, LastAction['state']>();

    return (operationId: string, state: LastAction['state'] | undefined): void => {
        if (state === undefined) return;
        const previous = seen.get(operationId);
        seen.set(operationId, state);
        if (previous === undefined || isTerminal(previous) || !isTerminal(state)) return;
        for (const key of operationInvalidationKeys(releaseId)) invalidate(key);
    };
}
